import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export default function NotificationSettings() {
  return <>
    <CommonAppbar isMainPage={false} pageHeader={'Notification settings'}/>
    <FormControlLabel control={<Switch defaultChecked/>} label="Push Notifications" labelPlacement="start"/>
  </>
}
